import { useId, useState } from 'react'
import MetaPhaseSymbol from '../brand/MetaPhaseSymbol'
import { OPERATOR, PRODUCT_NAME } from '../../content/provenance'
import { EVENT_NAME } from '../../content/event'

/**
 * The pre-header, in the shape of the Mission Protoware sites: who built this
 * and how to know the connection is secure.
 *
 * White on navy (#0a2240) is 15.96:1; the orange link is 5.28:1. The panel
 * opens in place, below the line, and the control reports its state.
 */
function Lock() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      className="mt-0.5 shrink-0" aria-hidden="true">
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  )
}

export default function UtilityBanner() {
  const [open, setOpen] = useState(false)
  const panelId = useId()

  return (
    <div className="w-full bg-[var(--color-navy)] text-white">
      <div className="page-shell flex flex-wrap items-center justify-center gap-x-3 gap-y-1 py-2 text-sm">
        <MetaPhaseSymbol className="size-5 shrink-0 text-[var(--color-accent-500)]" />
        <span>Built by {OPERATOR.name}.</span>
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls={panelId}
          className="inline-flex cursor-pointer items-center gap-1 underline underline-offset-4"
        >
          Here&apos;s how you know
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
            className={open ? undefined : 'rotate-180'}>
            <path d="M12 6 4 16h16z" />
          </svg>
        </button>
      </div>

      {open && (
        <div id={panelId} className="border-t border-white/20">
          <div className="page-shell grid gap-6 py-5 text-sm sm:grid-cols-2">
            <div className="flex gap-3">
              <MetaPhaseSymbol className="size-7 shrink-0 text-[var(--color-accent-500)]" />
              <div>
                <p className="font-bold">
                  Built by{' '}
                  <a href={OPERATOR.url} rel="noreferrer" className="text-[var(--color-accent-500)] underline underline-offset-4">
                    {OPERATOR.name}
                  </a>
                </p>
                <p className="mt-1 leading-relaxed text-white/90">
                  {PRODUCT_NAME} is the {EVENT_NAME} site, built and operated by {OPERATOR.name} as Mission Protoware.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <Lock />
              <div>
                <p className="font-bold">
                  Secure <code className="font-mono">https://</code> connection
                </p>
                <p className="mt-1 leading-relaxed text-white/90">
                  A lock icon or <code className="font-mono">https://</code> means you are connected securely. Every page
                  here requires HTTPS.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
